import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyflowSortFilterControlComponent } from './buyflow-sort-filter-control.component';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MoreFiltersModalComponent } from '../modals/more-filters/more-filters-modal.component';
import { SkeletonLoadModule } from '../skeleton-load/skeleton-load.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    NgxSliderModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FormsModule,
    MatOptionModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    MatMenuModule,
    MatDialogModule,
    SkeletonLoadModule,
    SharedModule,
  ],
  exports: [BuyflowSortFilterControlComponent],
  declarations: [BuyflowSortFilterControlComponent, MoreFiltersModalComponent],
  entryComponents: [MoreFiltersModalComponent],
})
export class BuyflowSortFilterControlModule {}
